import { ResponsiveBar } from '@nivo/bar';
import React from 'react';


type BarGraphProps = {
    axis: {
        bottomLegend: string,
        leftLegend: string
    }
    data: {label: string, value: number}[] 
};



export const BarGraph: React.FC<BarGraphProps> = ({  axis, data }) => {
    return (
        <ResponsiveBar
            data={data}
            indexBy="label"
            margin={{ top: 30, right: 130, bottom: 120, left: 60 }}
            padding={0.6}
            colors={['#FFB30D', '#00CFEF', '#0C5C75', '#e3eff4']}
            defs={[]}
            keys={['value']}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 10,
                tickRotation: 60,
                legend: axis.bottomLegend,
                legendPosition: 'start',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: axis.leftLegend ,
                legendPosition: 'middle',
                legendOffset: 10,
            }}
            labelSkipHeight={12}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}

        />
    )
} 